import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { 
    AppText, CustomContainer, FixedContainer, 
    FlexColumn, 
    FlexRow, SidePopupContainer 
} from "src/style"
import TransferIcon from 'src/assets/svg/transfer-icon'
import TransferIconD2 from 'src/assets/svg/transfer-icon-d2'
import AirtimeIcon from 'src/assets/svg/airtime-icon'
import AirtimeIconD2 from 'src/assets/svg/airtime-icon-d2'
import BillsIcon from 'src/assets/svg/bills-icon'
import BillsIconD2 from 'src/assets/svg/bills-icon-d2'
import CardlessWithdrawalIcon from 'src/assets/svg/cardless-withdrawal-icon'
import CardlessWithdrawalIconD2 from 'src/assets/svg/cardless-withdrawal-icon-d2'
import TransferIconD3 from 'src/assets/svg/transfer-icon-d3'
import AirtimeIconD3 from 'src/assets/svg/airtime-icon-d3'
import BillsIconD3 from 'src/assets/svg/bills-icon-d3'
import CardlessWithdrawalIconD3 from 'src/assets/svg/cardless-withdrawal-icon-d3'
import { Design, Features } from "src/model"

export const QuickLinks: React.FC<any> = ({isTransfer, isAirtime_Data, isBillsPayment, isCardlessWithdrawal, close}) => {
    const {info: {institutionData}} = useContext(AppInfoContext)

    function handleClick (method: any) {
        method()
        close()
    }
    
    return (
        <>
            <SidePopupContainer zIndex="7" onClick={close} bgColor='transparent' />
            <FixedContainer top="10" zIndex="8" className="quicklinks-fix-container">
                <CustomContainer
                    width="25" minHeight="10" bgColor="#ffffff"
                    borderColor="#F7FAFC" padding="1" topPadding="2" bottomPadding="2" radius="0.8"
                    shadow="0px 0px 1px rgba(12, 26, 75, 0.1), 0px 30px 40px rgba(20, 37, 63, 0.08)"
                >
                    { (institutionData.featureIDs?.includes(Features.INTER_BANK_TRANSFER) || institutionData.featureIDs?.includes(Features.INTRA_BANK_TRANSFER)) &&
                        <FlexColumn
                            minHeight="4.5" alignItems="flex-start" hoverBgColor="#E7F6F5"
                            className="quick-links-items"
                        >
                            <FlexRow 
                                gap='1.5' width='auto' sizeUnit='' 
                                onClick={() => handleClick(isTransfer)}
                            >
                                {
                                    institutionData?.design === Design.DESIGN_3 ?
                                        <TransferIconD3 className='icon-component' />
                                        : institutionData?.design === Design.DESIGN_2 ?
                                            <TransferIconD2 className='icon-component' />
                                                : <TransferIcon className='icon-component' />
                                }
                                <AppText 
                                    textSize='1.6' fontWeight='600' color='#25282B' 
                                    cursor='pointer' hoverColor='#0D968F'
                                >
                                    Transfer
                                </AppText>
                            </FlexRow>
                        </FlexColumn>
                    }
                    { institutionData.featureIDs?.includes(Features.AIRTIME_TOPUP) &&
                        <FlexColumn 
                            minHeight="4.5" alignItems="flex-start" hoverBgColor="#E7F6F5"
                            className="quick-links-items"
                            onClick={() => handleClick(isAirtime_Data)}
                        >
                            <FlexRow gap='1.5' width='auto' sizeUnit=''>
                                {
                                    institutionData?.design === Design.DESIGN_3 ?
                                        <AirtimeIconD3 className='icon-component' />
                                        : institutionData?.design === Design.DESIGN_2 ?
                                            <AirtimeIconD2 className='icon-component' />
                                                : <AirtimeIcon className='icon-component' />
                                }
                                <AppText 
                                    textSize='1.6' fontWeight='600' color='#25282B' 
                                    cursor='pointer' hoverColor='#0D968F'
                                >
                                    Airtime
                                </AppText>
                            </FlexRow>
                        </FlexColumn>
                    }
                    { institutionData.featureIDs?.includes(Features.BILLS_PAYMENT) &&
                        <FlexColumn 
                            minHeight="4.5" alignItems="flex-start" hoverBgColor="#E7F6F5"
                            className="quick-links-items"
                            onClick={() => handleClick(isBillsPayment)}
                        >
                            <FlexRow gap='1.5' width='auto' sizeUnit=''>
                                {
                                    institutionData?.design === Design.DESIGN_3 ?
                                        <BillsIconD3 className='icon-component' />
                                        : institutionData?.design === Design.DESIGN_2 ?
                                            <BillsIconD2 className='icon-component' />
                                                : <BillsIcon className='icon-component' />
                                }
                                <AppText 
                                    textSize='1.6' fontWeight='600' color='#25282B' 
                                    cursor='pointer' hoverColor='#0D968F'
                                >
                                    Bills
                                </AppText>
                            </FlexRow>
                        </FlexColumn>
                    }
                    <FlexColumn 
                        minHeight="4.5" alignItems="flex-start" hoverBgColor="#E7F6F5"
                        className="quick-links-items"
                        onClick={() => handleClick(isCardlessWithdrawal)}
                    >
                        <FlexRow gap='1.5' width='auto' sizeUnit=''>
                            {
                                institutionData?.design === Design.DESIGN_3 ?
                                    <CardlessWithdrawalIconD3 className='icon-component' />
                                    : institutionData?.design === Design.DESIGN_2 ?
                                        <CardlessWithdrawalIconD2 className='icon-component' />
                                            : <CardlessWithdrawalIcon className='icon-component' />
                            }
                            <AppText 
                                textSize='1.6' fontWeight='600' color='#25282B' ////#ADADAD
                                cursor='pointer' hoverColor='#0D968F' //#ADADAD
                            >
                                Cardless Withdrawal
                            </AppText>
                        </FlexRow>
                    </FlexColumn>
                </CustomContainer>
            </FixedContainer>
        </>
    )
}